/* global axios */

import ApiClient from './ApiClient';

class CommMenusAPI extends ApiClient {
  constructor() {
    super('comm_menus', { accountScoped: true });
  }

  current(sessionId = null) {
    const config = {};
    if (sessionId) {
      config.headers = { 'X-Comm-Session-Id': sessionId };
    }
    return axios.get(`${this.url}/current`, config);
  }

  dismiss(menuId, sessionId = null) {
    const config = {};
    if (sessionId) {
      config.headers = { 'X-Comm-Session-Id': sessionId };
    }
    return axios.post(`${this.url}/${menuId}/dismiss`, {}, config);
  }

  actionClicked(menuId, actionId = null, sessionId = null) {
    const config = {};
    if (sessionId) {
      config.headers = { 'X-Comm-Session-Id': sessionId };
    }
    return axios.post(`${this.url}/${menuId}/action_clicked`, { action_id: actionId }, config);
  }

  // Keep for backwards compatibility
  secondaryActionClicked(menuId, sessionId = null) {
    return this.actionClicked(menuId, null, sessionId);
  }

  // Complete a checklist item
  completeChecklistItem(menuId, itemId, sessionId = null) {
    const config = {};
    if (sessionId) {
      config.headers = { 'X-Comm-Session-Id': sessionId };
    }
    return axios.post(`${this.url}/${menuId}/complete_checklist_item`, { item_id: itemId }, config);
  }
}

export default new CommMenusAPI();
